<template>
  <el-container style="width: 100vw; margin: 0 auto; height: 97vh">
    <el-aside
      style="
        background: white;
        align-items: center;
        display: flex;
        flex-direction: column;
      "
    >
      <el-image
        style="
          width: 80%;
          height: 100px;
          margin: 20px auto;
          border-radius: 10px;
        "
        :src="require('@/assets/corner.png')"
      />
      <el-menu
        default-active="/mapManage"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        unique-opened="true"
        router="true"
      >
        <el-sub-menu index="1" @click="changeTitle('地图')">
          <template #title>
            <el-icon><location /></el-icon>
            <span>地图</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/mapManage"> 我的地图 </el-menu-item>
            <!-- <el-menu-item index="1-2">示例地图</el-menu-item> -->
          </el-menu-item-group>
        </el-sub-menu>

        <el-sub-menu index="2" @click="changeTitle('机构')">
          <template #title>
            <el-icon><User /></el-icon>
            <span>机构</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/branchManage"> 机构设置 </el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
        <el-sub-menu index="4" @click="changeTitle('日志')">
          <template #title>
            <el-icon><setting /></el-icon>
            <span>日志</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="4-1">公共日志</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
      </el-menu>
    </el-aside>
    <!-- <el-container style="background: rgba(248, 248, 248, 1)">

      <el-main>
        <h3>{{ titleName }}</h3>

        <div
          v-if="titleName === '地图'"
          style="
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: left;
            align-items: flex-start;
          "
        >
          <el-card
            v-for="region in regions"
            :key="index"
            class="map-card draw-card"
            @click="drawMap(region.regionId)"
          >
            <div class="postal-type" v-if="region.postalType == 0">
              普通快递
            </div>
            <div class="postal-type" v-else>特快专递</div>
            {{ region.regionName }}
          </el-card>
          <el-card class="map-card">
            <el-button :icon="Plus" circle @click="mapDialogVisible = true" />
          </el-card>
        </div>
        <div v-if="titleName === '团队'">
          <div class="team">
            <div class="team-child">
              <div class="team-name">
                {{ organizationName }}
              </div>
              <div style="margin-left: 10px">
                <el-button :icon="Edit" circle @click="editName" />
              </div>
            </div>
            <div class="team-child">
              <div>
                <el-button :icon="Plus" circle @click="goAddMember" />
              </div>
            </div>
          </div>
          <el-table border :data="memberList" style="width: 100%">
            <el-table-column prop="memberName" label="成员名称" />
            <el-table-column prop="permissionType" label="角色">
              <template #default="scope">{{
                getPermissionTypeText(scope.row.permissionType)
              }}</template>
            </el-table-column>
            <el-table-column prop="phoneNumber" label="电话号码" />
            <el-table-column label="操作">
              <template #default="scope">
                <el-button
                  type="primary"
                  v-if="scope.row.permissionType != 1"
                  @click="goEditMember(scope.row)"
                  >修改</el-button
                >
                <el-button
                  type="danger"
                  v-if="scope.row.permissionType != 1"
                  @click="goRemoveMember(scope.row)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          v-if="titleName === '日志'"
          style="display: flex; flex-direction: column"
        >
          <div style="display: flex; flex-direction: row">
            <div class="data-div" style="width: 30%; margin-left: 20px">
              <span class="data-div-font">地图数量</span>
              <span class="data-div-font">42</span>
            </div>
            <div class="data-div" style="width: 30%; margin-left: 20px">
              <span class="data-div-font">记录数量</span>
              <span class="data-div-font"> 12789</span>
            </div>
            <div class="data-div" style="width: 30%; margin-left: 20px">
              <span class="data-div-font">成员数</span>
              <span class="data-div-font">6</span>
            </div>
          </div>
          <div style="display: flex; flex-direction: row">
            <div
              class="data-div"
              style="width: 45%; margin-left: 20px; height: 200px"
            >
              记录数
            </div>
            <div
              class="data-div"
              style="width: 45%; margin-left: 20px; height: 200px"
            >
              路线规划数量
            </div>
          </div>
          <div>
            <div
              class="data-div"
              style="width: 94.3%; margin-left: 20px; height: 200px"
            >
              分单次数
            </div>
          </div>
        </div>
      </el-main>
    </el-container> -->

    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>

  <!-- 团队管理 -->
  <!-- <el-dialog v-model="memberAddDialogVisible" title="添加成员" width="500">
    <el-form :model="memberInfo" label-position="right" label-width="auto">
      <el-form-item label="成员名称">
        <el-input v-model="memberInfo.memberName" autocomplete="off" />
      </el-form-item>
      <el-form-item label="电话号码">
        <el-input v-model="memberInfo.phoneNumber" autocomplete="off" />
      </el-form-item>
      <el-form-item label="密码">
        <el-input
          v-model="memberInfo.password"
          autocomplete="off"
          type="password"
        />
      </el-form-item>
      <el-form-item label="成员角色">
        <el-select
          v-model="memberInfo.permissionType"
          placeholder="请选择成员角色"
        >
          <el-option label="管理员" :value="2" />
          <el-option label="快递员" :value="3" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="memberAddDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addMember"> 确认 </el-button>
      </div>
    </template>
  </el-dialog> -->

  <!-- <el-dialog v-model="memberEditDialogVisible" title="修改成员信息" width="500">
    <el-form :model="memberEditInfo" label-position="right" label-width="auto">
      <el-form-item label="成员名称">
        <el-input v-model="memberEditInfo.memberName" autocomplete="off" />
      </el-form-item>
      <el-form-item label="电话号码">
        <el-input v-model="memberEditInfo.phoneNumber" autocomplete="off" />
      </el-form-item>
      <el-form-item label="密码">
        <el-input
          v-model="memberEditInfo.password"
          autocomplete="off"
          type="password"
        />
      </el-form-item>
      <el-form-item label="成员角色">
        <el-select
          v-model="memberEditInfo.permissionType"
          placeholder="请选择成员角色"
        >
          <el-option label="管理员" :value="2" />
          <el-option label="快递员" :value="3" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="memberEditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="editMember"> 确认 </el-button>
      </div>
    </template>
  </el-dialog> -->
  <!-- 
  <el-dialog
    v-model="deleteConfirmDialogVisible"
    width="500"
    :before-close="handleClose"
  >
    <span>你确认要删除该成员吗</span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="deleteConfirmDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="removeMember"> 确认 </el-button>
      </div>
    </template>
  </el-dialog> -->
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { user, postal } from "../../../api/index";
import { ElMessage, ElMessageBox } from "element-plus";
const router = useRouter();
import {
  Plus,
  Edit,
  User,
  Location,
  Setting,
  Search,
  Bell,
  ChatDotSquare,
  Back,
} from "@element-plus/icons-vue";

const titleName = ref("地图");

const mapDialogVisible = ref(false);

const changeTitle = (title) => {
  titleName.value = title;
  if (title == "团队") {
    getOrganizationInfo();
  }
  if (title == "地图") {
    loadRegions();
  }
};

let regions = ref([]);
const loadRegions = () => {
  postal.getAllRegions().then((res) => {
    regions.value = res.data;
  });
};

let newRegion = reactive({
  regionName: "",
  postalType: 0,
});
const goAddRegion = () => {
  mapDialogVisible.value = false;
  postal.addRegion(newRegion).then((res) => {
    if (res.code == 200) {
      ElMessage({
        type: "success",
        message: `新建地图名称为:${newRegion.regionName}`,
      });
      loadRegions();
    } else {
      ElMessage({
        type: "error",
        message: `新建地图失败`,
      });
    }
  });
};
const drawMap = (regionId) => {
  router.push({
    path: "/draw",
    query: { regionId: regionId }, // Replace with your actual parameter name and value
  });
};
let memberList = ref([]);
let memberAddDialogVisible = ref(false);
let organizationName = ref();

let memberInfo = reactive({
  memberName: "",
  phoneNumber: "",
  password: "",
  permissionType: "",
});

function getOrganizationInfo() {
  user.getOrganizationInfo().then((res) => {
    if (res.code == 200) {
      memberList.value = res.data.organizationMembers;
      organizationName.value = res.data.organizationName;
    }
  });
}
function getPermissionTypeText(permissionType) {
  switch (permissionType) {
    case 1:
      return "项目经理";
    case 2:
      return "管理员";
    case 3:
      return "快递员";
    default:
      return "未知角色"; // Default text for unknown types
  }
}
const goAddMember = () => {
  memberInfo.memberName = "";
  memberInfo.phoneNumber = "";
  memberInfo.password = "";
  memberInfo.permissionType = "";
  memberAddDialogVisible.value = true;
};
const addMember = () => {
  user.addMember(memberInfo).then((res) => {
    if (res.code == 200) {
      ElMessage.success("添加成员成功");
      getOrganizationInfo();
    } else {
      ElMessage.error("添加成员失败");
    }
  });
  memberAddDialogVisible.value = false;
};

let memberEditDialogVisible = ref(false);

let memberEditInfo = reactive({
  memberId: 0,
  memberName: "",
  phoneNumber: "",
  password: "",
  permissionType: "",
});
const goEditMember = (data) => {
  memberEditInfo = data;
  memberEditDialogVisible.value = true;
};
const editMember = () => {
  user.editMember(memberEditInfo).then((res) => {
    if (res.code == 200) {
      ElMessage.success("修改成员信息成功");
      getOrganizationInfo();
    } else {
      ElMessage.error("修改成员信息失败");
    }
    memberEditDialogVisible.value = false;
  });
};
const editName = () => {
  ElMessageBox.prompt("请输入新的组织名称", "修改组织名称", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    inputPattern: /^.+$/,
    inputErrorMessage: "输入不为空",
  })
    .then(({ value }) => {
      ElMessage({
        type: "success",
        message: `新的组织名称为:${value}`,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "Input canceled",
      });
    });
};

let deleteConfirmDialogVisible = ref(false);
let memberToDelete = reactive({});
const goRemoveMember = (data) => {
  memberToDelete = data;
  deleteConfirmDialogVisible.value = true;
};
const removeMember = () => {
  user.removeMember(memberToDelete).then((res) => {
    if (res.code == 200) {
      ElMessage.success("删除成员成功");
      getOrganizationInfo();
    } else {
      ElMessage.error("删除成员失败");
    }
  });
  deleteConfirmDialogVisible.value = false;
};
onMounted(() => {});
</script>
<style scoped>
.map-card {
  width: 300px;
  height: 300px;
  margin: 20px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  text-align: center;
  line-height: 300px;
  font-size: 30px;
  color: #999;
}

.el-menu-vertical-demo {
  margin-top: 20px;
  width: 100%; /* 侧边栏宽度 */
  background-color: white; /* 背景色 */
  border-right: none; /* 隐藏边框 */
}

.el-menu-item {
  padding: 10px 20px; /* 菜单项内边距 */
  background-color: white; /* 背景色 */
}

.el-menu-item:hover {
  background-color: #e6f7ff; /* 鼠标悬停 */
}
.icon-link {
  width: 50px;
  height: 50px;
  text-decoration: none;
  border: none;
}
.icon-link:hover {
  text-decoration: none;
}
.icon {
  font-size: 20px;
  color: #999;
}
.data-div {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 10px 60px rgba(199, 199, 199, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 32px 32px 32px 32px;
  margin-top: 20px;
}
.data-div-font {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 22px;
  color: rgba(54, 65, 79, 1);
  text-align: left;
  vertical-align: middle;
}

.team {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 32px;
  margin-bottom: 10px;
}
.team-child {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 28px;
  line-height: 28px;
}

.draw-card {
  cursor: pointer;
}
.postal-type {
  height: 20px;
}
</style>
